import gql from 'graphql-tag';

export const GetMyDashboardQuery = gql`
  query GetMyDashboard($parentId: uuid) {
    babies(
      where: {
        parent: {
          _or: [
            { shared: { invitedParentId: { _eq: $parentId } } }
            { id: { _eq: $parentId } }
          ]
        }
      }
      order_by: { dob: desc }
    ) {
      id
      dob
      gender
      name
      delivery
      preterm
      parent_id
      tests(order_by: { createdAt: desc }) {
        id
        createdAt
        status
      }
    }
  }
`;
